import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AppActions } from "@state/actions/app.actions";
import { tap } from "rxjs";

@Injectable()
export class AppEffects {
  openNfePage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AppActions.selectBudget),
        tap(() => {
          this.router.navigate(["/nfe"]);
        })
      );
    },
    {
      dispatch: false
    }
  );

  openNfseFromBudget$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AppActions.selectBudgetForNfse),
        tap(() => {
          this.router.navigate(["/nfse"]);
        })
      );
    },
    {
      dispatch: false
    }
  );

  openNfceFromBudget$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AppActions.selectBudgetForNfce),
        tap(() => {
          this.router.navigate(["/nfce"]);
        })
      );
    },
    {
      dispatch: false
    }
  );

  openNfsePage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AppActions.addService),
        tap(() => {
          // Navega apenas se for o primeiro serviço adicionado
          const currentUrl = this.router.url;
          if (currentUrl !== "/nfse") {
            this.router.navigate(["/nfse"]);
          }
        })
      );
    },
    { dispatch: false }
  );

  openProductPage$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AppActions.selectItemToEdit),
        tap(() => {
          this.router.navigate(["/product"]);
        })
      );
    },
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private router: Router
  ) {}
}
